import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import i18n from "./i18n";
import "./assets/design-tokens.css";
import { trackVisit } from "./analytics/tracker";

const app = createApp(App);

// ROUTER - i18n 
// Adjusts the lang param to the laguage selected
// Check in router.js --> path: "/:lang",
router.afterEach((to) => {
  if (to.name !== 'stats') trackVisit();
});

router.beforeEach((to, from, next) => {
  // set i18n locale from route param (fallback to 'en')
  const language = to.params.lang || 'en';
  i18n.global.locale.value = language;

  // Auth guard + logging/fallbacks
  // Check if route requires authentication
  const requiresAuth = to.matched.some((record) => record.meta && record.meta.requiresAuth);

  if (requiresAuth) {
    // Check if user is authenticated
    const isAuthenticated = sessionStorage.getItem('isAuthenticated') === 'true';

    // If not authenticated, redirect to login page
    if (!isAuthenticated) {
      console.warn('[auth] Navigation blocked — redirecting to protected-portal');
      return next({
        name: 'login',
        params: { lang: to.params.lang || language },
        query: { redirect: to.fullPath }, // AFTER login: redirect to intended page 
      });
    }
  }

  next();
});

app.use(i18n);
app.use(router);
app.config.globalProperties.colorMode = 'light'; // Color mode - theme
app.mount("#app");
